import React from "react";

const WhyChoose: React.FC = () => {
  return (
    <div>
      <div className="flex justify-center items-center w-full">
        <h3 className="text-lg sm:text-xl md:text-2xl lg:text-3xl xl:text-[3.8rem] xl:py-3">
          Why Organizations Choose Dream LMS
        </h3>
      </div>
      <div className="grid gap-5 md:grid-cols-3 pt-10">
        <div className="grid gap-5 ">
          <div className="bg-[#F3F3F3] p-4 custom-hover rounded-lg flex gap-3 items-center">
            <div className="w-6 sm:w-7 md:w-8 lg:w-9 xl:w-8">
              <img src="/learning/chat.svg" alt="" className="w-full" />
            </div>
            <div className="flex-1 pt- pb-4">
              <h4 className="font-bold text-[#182152] text-lg xl:text-xl">
                Engaged Workforce
              </h4>
              <p className="text-xs pt-1 sm:text-sm lg:text-base">
                Gamified learning and interactive content keep employees
                motivated.
              </p>
            </div>
          </div>
          <div className="bg-[#F3F3F3] p-4 custom-hover rounded-lg flex gap-3 items-center">
            <div className="w-6 sm:w-7 md:w-8 lg:w-9 xl:w-8">
              <img src="/learning/clipboard.svg" alt="" className="w-full" />
            </div>
            <div className="flex-1 pt-2  pb-4">
              <h4 className="font-bold text-[#182152] text-lg xl:text-xl">
                Compliance Made Easy
              </h4>
              <p className="text-xs pt-1 sm:text-sm">
                Automated tracking and certification tools ensure industry
                standards are met.
              </p>
            </div>
          </div>
          <div className="bg-[#F3F3F3] p-4 custom-hover rounded-lg flex gap-3 items-center">
            <div className="w-6 sm:w-7 md:w-8 lg:w-9 xl:w-8">
              <img
                src="/learning/personalised-learning.svg"
                alt=""
                className="w-full"
              />
            </div>
            <div className="flex-1 pt-2  pb-4">
              <h4 className="font-bold text-[#182152] text-lg xl:text-xl">
                Personalised Learning
              </h4>
              <p className="text-xs pt-1 sm:text-sm">
                Tailored courses and AI-driven skill gap analysis to meet
                individual needs.
              </p>
            </div>
          </div>
        </div>
        <div className="flex justify-center hover:scale-105 transition-all ease-out duration-200 items-center">
          <div className="py-5 xl:py-8">
            <img src="/learning/choose.png" className="w-56 md:w-72" alt="" />
          </div>
        </div>
        <div className="grid gap-5">
          <div className="bg-[#F3F3F3] p-4 custom-hover rounded-lg flex gap-3 items-center">
            <div className="w-6 sm:w-7 md:w-8 lg:w-9 xl:w-8">
              <img src="/learning/yoga.svg" alt="" className="w-full" />
            </div>
            <div className="flex-1 pt- pb-4">
              <h4 className="font-bold text-[#182152] text-lg xl:text-xl">
                Improved Productivity
              </h4>
              <p className="text-xs pt-1 sm:text-sm">
                Easy-to-access training ensures skills are up-to-date.
              </p>
            </div>
          </div>
          <div className="bg-[#F3F3F3] p-4 custom-hover rounded-lg flex gap-3 items-center">
            <div className="w-6 sm:w-7 md:w-8 lg:w-9 xl:w-8">
              <img src="/learning/data-driven.svg" alt="" className="w-full" />
            </div>
            <div className="flex-1 pt-2  pb-4">
              <h4 className="font-bold text-[#182152] text-lg xl:text-xl">
                Data-Driven Decisions
              </h4>
              <p className="text-xs pt-1 sm:text-sm">
                Detailed reporting highlights trends and areas for improvement.
              </p>
            </div>
          </div>
          <div className="bg-[#F3F3F3] p-4 custom-hover rounded-lg flex gap-3 items-center">
            <div className="w-6 sm:w-7 md:w-8 lg:w-9 xl:w-8">
              <img
                src="/learning/mobile-friendly.svg"
                alt=""
                className="w-full"
              />
            </div>
            <div className="flex-1 pt-2  pb-4">
              <h4 className="font-bold text-[#182152] text-lg xl:text-xl">
                Mobile-Friendly:
              </h4>
              <p className="text-xs pt-1 sm:text-sm">
                Learn anywhere, anytime, on any device.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhyChoose;
